// this is to create project token map for smooth flow in  time line scheduler
export default {
  namespaced: true,
  state: {
    searchKeywordWf: ''
  },
  getters: {
    searchKeywordWf: state => state.searchKeywordWf
  },
  mutations: {
    setSearchKeywordWf (state, { keyword }) {
      state.searchKeywordWf = keyword
    },
    clearSearchKeywordWf (state, action) {
      state.searchKeywordWf = ''
    }
  }
}
